import InputGroup from "../InputGroup";
import BenefitMessagePreview from "../../layout/BenefitMessagePreview";
import React, {useEffect, useState} from "react";
import {Check} from "lucide-react";
import {RadioGroup} from "omoplay";

const BenefitPrizeMessage = ({isAdult, isSendBlocked, benefitDetails, onChangeButtonName, onChangeIsAdult, onChangeIsSendBlocked}) => {
    const benefitData = benefitDetails().benefit
    const buttonName = benefitData.buttonName ?? benefitDetails().buttonName
    const [giftMessage, setGiftMessage] = useState("이벤트 당첨을 진심으로 축하드립니다.\n" +
        "앞으로도 뜨거운 성원 부탁드립니다.")
    const [flagSendBlocked, setFlagSendBlocked] = useState(isSendBlocked)


    const message = "안녕하세요 [업체명]입니다.\n\n" +
        "이벤트에 참여해주셔서 감사합니다.\n\n" +
        "고객님이 당첨된 쿠폰은 [쿠폰명] 입니다.\n\n" +
        "쿠폰 사용 기한은 [쿠폰사용기한]까지 입니다."

    const image = "https://mud-kage.kakao.com/dn/cuOtM8/dJMcagEf4G8/WeiNqHHtBIpxFe5n9xDMBk/img_l.jpg"

    useEffect(() => {
        onChangeButtonName(buttonName)
    }, []);

    return (
        <>
            {
                benefitData.type === "KAKAO" ? (
                    <InputGroup label="당첨 선물함 메시지" description="선물함에서 보이는 메시지를 입력 하세요.">
                        <textarea
                            placeholder="선물함 메시지를 입력 하세요."
                            onChange={(e) => setGiftMessage(e.target.value)}
                            className="w-full h-[100px] border border-gray-300 text-gray-900 rounded-lg focus:ring-indigo-500 focus:border-indigo-500 block p-2.5  resize-none whitespace-pre-line"
                            value={giftMessage}
                        />
                    </InputGroup>
                ) : (
                    <InputGroup label="기본 당첨 메시지" description="혜택 지급시 나가는 메시지입니다.">
                        <div className="flex-col gap-4">
                            <h4 className="text-sm font-bold text-gray-900 flex items-center gap-2">
                                <span className="w-1 h-4 bg-black rounded-full"></span>
                                메시지 전송 금지
                            </h4>
                            <div className="text-red-500">* 메시지 전송이 필요 없는 경우에만 On 하세요</div>
                            <RadioGroup key={isSendBlocked}
                                        items={[{label: "On", value: "true"}, {label: "Off", value: "false"}]}
                                        initChecked={isSendBlocked ? "true" : "false"}
                                        onSelected={(value) => {
                                            onChangeIsSendBlocked(value === "true")
                                            setFlagSendBlocked(value === "true")
                                        }} />

                            {
                                !flagSendBlocked && (
                                    <>
                                        <div className="space-y-3">
                                            <h4 className="text-sm font-bold text-gray-900 flex items-center gap-2">
                                                <span className="w-1 h-4 bg-black rounded-full"></span>
                                                연령 인증
                                            </h4>
                                            <label className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-all ${isAdult ? 'bg-gray-800 text-white border-gray-800' : 'bg-white border-gray-200 hover:bg-gray-50'}`}>
                                                <div className={`w-4 h-4 rounded border flex items-center justify-center ${isAdult ? 'bg-white border-white' : 'bg-white border-gray-300'}`}>
                                                    {isAdult && <Check size={10} className="text-black" />}
                                                </div>
                                                <input type="checkbox" className="hidden" checked={isAdult}
                                                       onChange={(e) => onChangeIsAdult(e.target.checked)}
                                                />
                                                <span className="text-sm font-medium">성인 인증 필요 (주류 등)</span>
                                            </label>
                                            <div className="text-red-500">* 성인 인증 체크시 친구톡으로 나가게 됩니다.</div>
                                        </div>
                                        <div className="bg-grey-0 flex-center-all flex-1 pl-[12px] pb-[12px]">
                                            <BenefitMessagePreview
                                                preview={
                                                    <div className="relative h-full bg-repeat-round bg-contain bg-[#ABC1D1] p-4 overflow-auto">
                                                        <h4 className="font-semibold text-gray-800 pl-2 py-2">
                                                            당첨 카카오톡 안내
                                                        </h4>
                                                        <div className="flex w-full flex-col justify-center bg-white rounded-lg p-2.5">
                                                            <img alt="" src={image} />
                                                            <div className="mt-2 text-xs whitespace-pre-line">{message}</div>
                                                            <button className="bg-[#F5F5F5] py-1 text-[#474A4E] text-sm font-semibold rounded mt-4">
                                                                쿠폰 확인하기
                                                            </button>
                                                        </div>
                                                    </div>
                                                }
                                            />
                                        </div>
                                    </>
                                )
                            }

                        </div>
                    </InputGroup>
                )
            }
        </>
  )
};

export default BenefitPrizeMessage;
